<script>
    import { onMount } from "svelte";

    import AlertType from "../../Alerts/AlertType";

    import AlertsStore from "../../Alerts/Store";
    import IconMode from "../../Map/Enums/IconMode";
    import KeyComponent from "./KeyComponent.svelte";

    let mode = AlertsStore.iconMode;

    let inittedDefaultKey = AlertsStore.meta.defaultKeyInitted;
	let hasRimKey = AlertsStore.filters.alertTypes[ AlertType.RIM ].exists;

    let availableModes = [];

    export let defaultModeName = "Alert Type";
    export let canHaveRimKey = false;
    export let disabled = false;

	$: {
		availableModes = [
            IconMode.ALERT,
            IconMode.TIME_DIFFERENCE,
            IconMode.SPEED,
            IconMode.VESSEL_TYPE,
            IconMode.INDEX
        ];
        if ($hasRimKey) {
            if (canHaveRimKey) { 
                availableModes.push( IconMode.RISK_LEVEL );
                if (!$inittedDefaultKey) {
                    $mode = IconMode.RISK_LEVEL;
                    $inittedDefaultKey = true;
                }
            }
            else {
                if ($mode == IconMode.RISK_LEVEL) {
                    $mode = IconMode.ALERT;
                }
            }
		}
	};

   
    

</script>

<KeyComponent title={"Vessel Icons"} mode={mode} iconType={"vessel"} defaultModeName={defaultModeName} availableModes={availableModes} disabled={disabled} />
